/**
 * @fileoverview Context for the RTC
 *
 * @example
 * // Usage:
 * import { RTCContext } from './RTCContext'
 *
 * function Component() {
 *   // ...
 * }
 */

import { createContext } from 'react'

export const RTCContext = createContext<RTCConfiguration>({})
